/**
 * @description 库存分析-tabsFBA详情货件模块
 */
<template>
    <div class="details-shipment">
        <app-filter-group
            @query="$gjQuery"
            @reset="$gjQueryInitParams">
            <gj-select-input
                v-model="filter.keyword"
                :options="[
                    {id: 'shipmentId', text: 'ShipmentId'},
                    {id: 'shipmentName', text: '货件名称'},
                    {id: 'centerId', text: '亚马逊代码'}
                ]"
                :width="['120px', '100px']"
            ></gj-select-input>
            <gj-select
                v-model="filter.status"
                :options="FbaShipmentEnum.statusOption"
                multiple
                collapse-tags
                placeholder="单据状态"
                width="191px">
            </gj-select>
        </app-filter-group>
        <gj-table
            ref="gjTable"
            size='has-picture'
            name="flag"
            :data="tableData"
            :columns="columns"
            :loading="loading"
            :adapt-height="false"
            :height="400"
            :default-sort="{prop: 'quantityShipped', order: 'descending'}"
            border="default"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
        </gj-table>
    </div>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import { DETAILS_SHIPMENT_COLUMN } from "../config.js"
import { storageAnalysisShipmentList } from "@/api/statistics";
import {FbaShipmentEnum} from "@/views/modules/common/logistics/enum";
export default {
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
    inject: ["getPageParams"],
    computed: {
        pageParams () {
            return this.getPageParams()
        },
    },
    data() {
        return {
            FbaShipmentEnum: FbaShipmentEnum,
            filter: {
                keyword: {
                    key: 'shipmentId',
                    value: ""
                },
                status: []
            },
            tableData: [],
            columns: DETAILS_SHIPMENT_COLUMN,
            loading: false,
        }
    },
    methods: {
        $gjQueryInitParams() {
            this.filter.keyword = { key: 'shipmentId', value: "" }
            this.filter.status = []
        },
        $gjQuery() {
           this.storageAnalysisShipmentList()
        },
        // 获取list数据
        async storageAnalysisShipmentList() {
            this.loading = true
            try {
                let res = await storageAnalysisShipmentList(this.structureParams())
                this.tableData = res
            } finally {
                this.loading = false
            }
        },
        // 构造params
        structureParams() {
            let params = {
                asinCode: this.pageParams.asinCode, //ASIN类型值
                asinType: this.pageParams.asinType, //ASIN类型（子asin：child，父asin：parent）
                centerId: "", //亚马逊仓代码
                shipmentId: "", //ShipmentId
                asinCshipmentNameode: "", //货件名称
                countryIds: this.pageParams.countryData.countryIds, //国家编码集合
                marketIds: this.pageParams.countryData.marketIds, //店铺id集合
                shipmentStatusList: this.filter.status, //单据状态
                ...this.querySort
            }
            if (this.filter.keyword.key) {
                params[this.filter.keyword.key] = this.filter.keyword.value
            }
            return params
        }
    },
    created() {
        this.sort.prop = "quantityShipped"
    }
};
</script>

<style scoped lang="scss">
.details-shipment {
    padding-top: 15px;
    /deep/.filter-group {
        padding-bottom: 10px;
    }
}
</style>
